// CSS Modules - component class name prefix: EventTeaser__

<template>
  <figure :class="$style.container">
    <a :class="$style.mediaLink" :href="data.primaryLink" target="_self">
      <img :src="data.image" :alt="data.name" />
    </a>
    <figcaption>
      <a :class="$style.secondaryLink" :href="data.secondaryLink">{{
        data.category
      }}</a>
      <a :class="$style.primaryLink" :href="data.primaryLink">
        <h3>{{ data.name }}</h3>
        <div>{{ data.date }}</div>
        <div><Flag :flag="data.flag" />{{ data.city }}</div>
        <div>{{ data.location }}</div>
      </a>
    </figcaption>
  </figure>
</template>

<script>
import Flag from "../Flag/Flag";

export default {
  name: "EventTeaser",
  components: {
    Flag
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style module lang="scss">
@import "./EventTeaser.scss";
</style>
